export const state = {
    user: {},
    game: {},
    gifts: [],
    winGift: {},
    address: {},
    histories: [],
    historyByLangAndPage: {},
    totalHistory: 0,
    isShowing: false
}
